<template>
  <section>
    <Feature :title="$t('QUOTATION_DATA_DETAIL')" :iconClass="'fa-check-square'">
      <FormRow :fieldNameArr="[this.$t('GROUP_KEY')]">
        <Input v-model="groupId" slot="a" disabled />
      </FormRow>
      <Collapse :accordion="true">
        <Panel v-if="isWaitingBuyer || isWaitingSupplier">
          {{ $t("LABEL_TEXT_BATCH_DELETE") }}
          <Form label-position="right" :label-width="120" :inline="true" slot="content">
            <FormItem :label="$t('ALERT_TYPE')">
              <Select style="width: 200px" v-model="deleteType" :placeholder="$t('CHOOSE')">
                <Option value="ALL">All</Option>
                <Option value="RED">Red</Option>
                <Option value="YELLOW">Yellow</Option>
                <Option value="RED_YELLOW">Red+Yellow</Option>
              </Select>
            </FormItem>
            <FormItem :label="$t('DELETE_REASON')">
              <Icon type="ios-create" size="28" class="text-delta-blue" @click="showDeleteReasonModal" />
            </FormItem>
            <FormItem>
              <Button type="primary" @click="batchDelete">{{ $t("BUTTON_TEXT_DELETE") }}</Button>
            </FormItem>
          </Form>
        </Panel>
        <Panel v-if="isWaitingBuyer">
          {{ $t("LABEL_TEXT_BATCH_EDIT") }}
          <Form label-position="right" :label-width="120" :inline="true" slot="content">
            <FormItem :label="$t('COMMENTS')">
              <Icon type="ios-create" size="28" class="text-delta-blue" @click="showBatchCommentsModal" />
            </FormItem>
            <FormItem :label="$t('VALID_FROM')">
              <DatePicker type="date" format="yyyy-MM-dd" :placeholder="$t('VALID_FROM')" v-model="batchValidFrom">
              </DatePicker>
            </FormItem>
            <FormItem :label="$t('VALID_TO')">
              <DatePicker type="date" format="yyyy-MM-dd" :placeholder="$t('VALID_TO')" v-model="batchValidTo">
              </DatePicker>
            </FormItem>
            <FormItem>
              <Button type="info" style="width: 300px" @click="showBatchApproveReferenceFileUploadModal">{{
                $t("APPROVE") }} {{ $t("REFERENCE_FILE") }} {{ $t("UPLOAD") }}</Button>
            </FormItem>
            <FormItem>
              <Button type="info" style="width: 300px" @click="showBatchRejectReferenceFileUploadModal">{{ $t("REJECT")
              }} {{ $t("REFERENCE_FILE") }} {{ $t("UPLOAD") }}</Button>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="batchSave">{{ $t("BUTTON_TEXT_SAVE") }}</Button>
            </FormItem>
          </Form>
        </Panel>
      </Collapse>
      <FormRow v-if="supplierQuotationFilesExited" :fieldNameArr="[$t('REFERENCE_FILE')]"> </FormRow>
      <FormRow v-if="supplierQuotationFilesExited" :fieldNameArr="['']">
        <Table width="600" border :columns="fileSchemaList" :data="showSupplierQuotationFiles" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
          </template>
        </Table>
      </FormRow>
      <br />
      <Table :columns="quotationColumnList" :data="quotationList" row-key="key"
        @on-selection-change="handleSelectChange">
        <template slot-scope="{ row, index }" slot="alert">
          <Icon type="ios-radio-button-on" size="28" :class="alertColorClass(row)" />
        </template>
        <template slot-scope="{ row, index }" slot="comments">
          <Icon type="ios-create" size="28" class="text-delta-blue" @click="showCommentsModal(index, row.uuid)" />
        </template>
        <template slot-scope="{ row, index }" slot="historyComments">
          <Icon type="ios-paper" size="28" class="text-delta-blue" @click="showHistoryCommentsModal(row.uuid)" />
        </template>
        <template slot-scope="{ row, index }" slot="newAndOld">
          <div>{{ row.currentPrice === undefined || row.currentPrice === null ? "NEW" : "OLD" }}</div>
        </template>
        <template slot-scope="{ row, index }" slot="infoRecord">
          <div v-if="row.infoRecordFlag">
            <span>YES</span>
            <Icon type="ios-create" size="28" class="text-delta-blue" @click="showInfoRecordMaintainModal(index)" />
          </div>
          <div v-else>
            <span>NO</span>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="highPrice">
          <div v-if="row.highPrice && row.quotationHighPrice">
            <Icon type="ios-warning" size="28" class="text-delta-red" />
            <span>{{ row.quotationHighPrice.priceDifference }}%</span>
            <br />
            <span>{{ row.quotationHighPrice.orgCheck === "C" ? "Cross" : "Single" }}</span>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="deltaPartAndDeltaPartDescription">
          <div>{{ row.partNo ? row.partNo : "" }}<br />{{ row.partDescription ? row.partDescription : "" }}</div>
        </template>
        <template slot-scope="{ row, index }" slot="itemCategory">
          <span v-if="quotationList[index].itemCategory === 'STANDARD'">Standard</span>
          <span v-if="quotationList[index].itemCategory === 'SUBCONTRACTION'">Subcontraction</span>
        </template>
        <template slot-scope="{ row, index }" slot="unitPriceAndCurrency">
          <div>{{ row.unitPrice ? row.unitPrice : "" }}/{{ row.currency ? row.currency : "" }}</div>
        </template>
        <template slot-scope="{ row, index }" slot="rfqCd">
          <div v-if="row.currentPrice">
            {{
              Math.floor(
                ((row.rfqQty * row.currentPrice - row.rfqQty * row.unitPrice) / (row.rfqQty * row.currentPrice)) *
                  100 *
                  100
              ) / 100
            }}
          </div>
          <div v-else>NA</div>
        </template>
        <template slot-scope="{ row, index }" slot="targetCd">
          <div v-if="row.unitPrice">
            {{
              Math.floor(
                ((row.rfqQty * row.targetPrice - row.rfqQty * row.unitPrice) / (row.rfqQty * row.targetPrice)) *
                  100 *
                  100
              ) / 100
            }}
          </div>
          <div v-else>NA</div>
        </template>
        <template slot-scope="{ row, index }" slot="validFromAndValidTo">
          <DatePicker v-model="quotationList[index].validFrom" type="date" format="yyyy-MM-dd"
            :disabled="!(isWaitingBuyer || isWaitingSupplier)" placeholder="Select Date"></DatePicker>
          <DatePicker v-model="quotationList[index].validTo" type="date" format="yyyy-MM-dd"
            :disabled="!(isWaitingBuyer || isWaitingSupplier)" placeholder="Select Date">
          </DatePicker>
        </template>
        <template slot-scope="{ row, index }" slot="scalePrice">
          <Icon
            :type="row.quotationScalePriceList && row.quotationScalePriceList.length > 0 ? 'md-reorder' : ''"
            size="28"
            class="text-delta-blue"
            @click="showScalePriceModal(index)"
          />
        </template>
      </Table>
      <Row v-if="quotationList.length > 0" type="flex" justify="space-between">
        <Col type="flex" justify="start">
          {{ $t("COMMON_TEXT_FROM") }} {{ pageObj.page * pageObj.pageSize - (pageObj.pageSize - 1) }}
          {{ $t("COMMON_TEXT_TO") }}
          <span v-if="pageObj.totalCount < pageObj.page * pageObj.pageSize">{{ pageObj.totalCount }}</span>
          <span v-else> {{ pageObj.page * pageObj.pageSize }}</span>
          {{ $t("COMMON_TEXT_OF") }} {{ pageObj.totalCount }} {{ $t("COMMON_TEXT_ENTRIES") }}
        </Col>
        <Col type="flex" justify="end">
          <Page
            :total="pageObj.totalCount"
            :page-size="pageObj.pageSize"
            :prev-text="$t('COMMON_TEXT_PREV')"
            :next-text="$t('COMMON_TEXT_NEXT')"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
            show-sizer
            :page-size-opts="[20, 50, 100]"
          >
          </Page>
        </Col>
      </Row>
    </Feature>
    <ButtonRow>
      <template v-if="isWaitingBuyer">
        <Button type="primary" @click="save" slot="1">{{ $t("SAVE") }}</Button>
        <Button type="success" @click="approve" slot="2">{{ $t("APPROVE") }}</Button>
        <Button type="error" @click="reject" slot="3">{{ $t("REJECT") }}</Button>
      </template>
      <template v-if="isWaitingSupplier">
        <Button type="error" @click="Delete" :disabled="isDeleteDisabled" slot="3">{{ $t("DELETE") }}</Button>
      </template>
      <Button type="info" @click="Back" slot="4">{{ $t("BACK") }}</Button>
      <Button type="info" @click="Download" slot="5">{{ $t("DOWNLOAD") }}</Button>
    </ButtonRow>
    <Modal
      :z-index="modalSize"
      :reset-drag-position="true"
      sticky
      :draggable="true"
      width="900"
      v-model="deleteReasonModal"
      :title="$t('DELETE_REASON')"
    >
      <froala :config="FloraEditorConfig" v-model="deleteReason"></froala>
    </Modal>
    <Modal
      :z-index="modalSize"
      :reset-drag-position="true"
      sticky
      :draggable="true"
      width="900"
      v-model="batchCommentsModal"
      :title="$t('COMMENTS')"
    >
      <froala :config="FloraEditorConfig" v-model="batchComments"></froala>
    </Modal>
    <Modal
      :z-index="modalSize"
      :reset-drag-position="true"
      sticky
      :draggable="true"
      width="900"
      v-model="scalePricesModal"
      :title="$t('SCALE_PRICE')"
    >
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table :columns="scalePriceColumnList" :data="scalePrices" max-height="800"></Table>
      </div>
    </Modal>
    <Modal v-model="commentsModal" :title="$t('COMMENTS')" :draggable="true" :sticky="true" :reset-drag-position="true"
      :ok-text="$t('SAVE')" :width="900" :z-index="modalSize" @on-ok="confirmComments"
      :footer-hide="!(isWaitingBuyer || isWaitingSupplier)">
      <froala :config="FloraEditorConfig" v-model="comments"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="logCommentModal" :title="$t('HISTORY') + ' ' + $t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="logComment"></froala>
    </Modal>
    <Modal
      :z-index="modalSize"
      :reset-drag-position="true"
      sticky
      :draggable="true"
      width="900"
      v-model="batchApproveReferenceFileUploadModal"
      :title="$t('APPROVE') + ' ' + $t('REFERENCE_FILE')"
    >
      <FormRow
        :fieldNameArr="[
          $t('QUOTATION_FILE_UPLOAD') + '(' + $t('FILE_SIZE_LESS_THAN_5MB') + ')',
          file === null ? '' : file.name,
        ]"
      >
        <Upload slot="a" :before-upload="handleUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t("UPLOAD") }}</Button>
        </Upload>
        <Button type="primary" v-show="file !== null" slot="b" @click="uploadApproveReferenceFile">{{
          $t("CLICK_UPLOAD")
        }}</Button>
      </FormRow>
      <Table width="600" border :columns="fileSchemaList" :data="cpcToSupervisorAttachments">
        <template slot-scope="{ row }" slot="action">
          <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
          <Button type="error" shape="circle" icon="md-close-circle" @click="deleteApproveReferenceFile(row)"></Button>
        </template>
      </Table>
    </Modal>
    <Modal
      :z-index="modalSize"
      :reset-drag-position="true"
      sticky
      :draggable="true"
      width="900"
      v-model="batchRejectReferenceFileUploadModal"
      :title="$t('REJECT') + ' ' + $t('REFERENCE_FILE')"
    >
      <FormRow
        :fieldNameArr="[
          $t('QUOTATION_FILE_UPLOAD') + '(' + $t('FILE_SIZE_LESS_THAN_5MB') + ')',
          file === null ? '' : file.name,
        ]"
      >
        <Upload slot="a" :before-upload="handleUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t("UPLOAD") }}</Button>
        </Upload>
        <Button type="primary" v-show="file !== null" slot="b" @click="uploadRejectReferenceFile">{{
          $t("CLICK_UPLOAD")
        }}</Button>
      </FormRow>
      <Table width="600" border :columns="fileSchemaList" :data="cpcToVendorAttachments">
        <template slot-scope="{ row }" slot="action">
          <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
          <Button type="error" shape="circle" icon="md-close-circle" @click="deleteRejectReferenceFile(row)"></Button>
        </template>
      </Table>
    </Modal>
    <Modal
      :z-index="modalSize"
      :reset-drag-position="true"
      sticky
      :draggable="true"
      width="900"
      v-model="infoRecordMaintainModal"
      :title="$t('INFO_RECORD_MAINTAIN')"
    >
      <InfoRecordMaintain
        v-if="infoRecordMaintainModal"
        :quotation="quotation"
        :materialTypeList="materialTypeList"
      ></InfoRecordMaintain>
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo, AlertDelete, AlertError } from "@/util/alert"
import { Translate, FloraEditorConfig, DownloadFile } from "@/util/common"
import { FileSchemaList } from "@/util/tableTitle"
import InfoRecordMaintain from "@/views/quotation/InfoRecordMaintain"

export default {
  name: "CpcDetailMaintain",
  components: {
    InfoRecordMaintain,
  },
  props: {
    rfqStatus: {
      type: String
    }
  },
  inject: ["reload"],
  data() {
    return {
      FloraEditorConfig: FloraEditorConfig(""),
      deleteType: "",
      pageObj: {
        page: 0,
        totalPage: 0,
        totalCount: 0,
        pageSize: 20,
        sort: ["partNo,asc"],
      },
      materialTypeList: [],
      deleteReasonModal: false,
      deleteReason: "",
      batchCommentsModal: false,
      batchComments: "",
      batchValidFrom: "",
      batchValidTo: "",
      batchApproveReferenceFileUploadModal: false,
      batchRejectReferenceFileUploadModal: false,
      infoRecordMaintainModal: false,
      scalePricesModal: false,
      commentsModal: false,
      logComment: "",
      logCommentModal: false,
      quotationUuid: "",
      supplierQuotationFiles: [],
      cpcToSupervisorAttachments: [],
      cpcToVendorAttachments: [],
      scalePrices: [],
      comments: "",
      flowComment: "",
      file: null,
      fileSchemaList: FileSchemaList(this),
      quotationList: [],
      selectedItems: []
    }
  },
  created() {
    const vueInstance = this
    if (vueInstance.groupId) {
      vueInstance.$quotationHttp.get("/quotation/material-type").then(response => {
        if (response.data) {
          vueInstance.materialTypeList = response.data
        }
      })
      vueInstance.$quotationHttp.get("/cpc/rfq/" + vueInstance.groupId + "/approveFiles").then(response => {
        if (response.data) {
          vueInstance.cpcToSupervisorAttachments = response.data
        }
      })
      vueInstance.$quotationHttp.get("/cpc/rfq/" + vueInstance.groupId + "/rejectFiles").then(response => {
        if (response.data) {
          vueInstance.cpcToVendorAttachments = response.data
        }
      })
      vueInstance.search(true)
    } else {
      vueInstance.$router.push({
        name: "CPC_MAINTAIN",
      })
    }
  },
  methods: {
    ...mapGetters([
      "getUserProfile",
      "getLanguage",
      "getCpcQuotationId",
      "getCpcDeltaPnSingle",
      "getCpcOaCode",
      "getCpcGroupId",
      "getCpcFormNo",
      "getCpcRfqType",
      "getCpcStatus",
      "getCpcDeltaPn",
      "getCpcVendorPn",
      "getCpcVendorCode",
      "getCpcFromRfqDate",
      "getCpcToRfqDate",
      "getCpcStatusEnum",
      "getCpcGroupUuid",
      "getModalSize",
      "getWindowsWidth",
    ]),
    ...mapActions(["toggleLoading"]),
    showDeleteReasonModal() {
      this.deleteReasonModal = true
    },
    showBatchCommentsModal() {
      this.batchCommentsModal = true
    },
    showBatchApproveReferenceFileUploadModal() {
      this.batchApproveReferenceFileUploadModal = true
    },
    showBatchRejectReferenceFileUploadModal() {
      this.batchRejectReferenceFileUploadModal = true
    },
    Back() {
      this.$router.push({ name: "CPC_MAINTAIN" })
    },
    search(init) {
      const vueInstance = this
      if (init) {
        vueInstance.pageObj = {
          page: 0,
          totalPage: 0,
          totalCount: 0,
          pageSize: 20,
          sort: ["partNo,asc"],
        }
      }
      vueInstance.toggleLoading(true)
      vueInstance.$quotationHttp
        .get(
          "/cpc/rfq/" +
            vueInstance.groupId +
            "/quotationDetails?page=" +
            vueInstance.pageObj.page +
            "&size=" +
            vueInstance.pageObj.pageSize +
            (vueInstance.pageObj.sort === undefined ||
            Array.isArray(vueInstance.pageObj.sort) === false ||
            vueInstance.pageObj.sort.length === 0
              ? ""
              : "&sort=" + vueInstance.pageObj.sort.join("&sort="))
        )
        .then(response => {
          vueInstance.quotationList = []
          vueInstance.quotationList = response.data.content
          vueInstance.quotationList.forEach(quotation => {
            quotation.validFrom =
              quotation.validFrom === undefined || quotation.validFrom === null
                ? new Date()
                : new Date(quotation.validFrom)
            quotation.validTo =
              quotation.validTo === undefined || quotation.validTo === null
                ? vueInstance.defaultValidTo
                : new Date(quotation.validTo)
          })
          vueInstance.pageObj = {
            page: response.data.number + 1,
            totalPage: response.data.totalPages,
            totalCount: response.data.totalElements,
            pageSize: response.data.size,
            sort: ["partNo,asc"],
          }
          if (vueInstance.quotationList.length === 0) {
            vueInstance.$Notice.success({
              title: Translate("COMMON_MESSAGE_INFO"),
              desc: Translate("COMMON_MESSAGE_INFO"),
              render: h => h("span", [Translate("COMMON_TEXT_NOTHING")]),
            })
          }
        })
        .catch(() => {
          console.error(error)
          AlertError(vueInstance, error).then(() => { })
        })
        .finally(() => {
          vueInstance.toggleLoading(false)
        })
    },
    changePageSize(newPageSize) {
      const vueInstance = this
      vueInstance.pageObj.pageSize = newPageSize
      vueInstance.pageObj.page = 0
      vueInstance.search(false)
    },
    changePage(page) {
      const vueInstance = this
      vueInstance.pageObj.page = page - 1
      vueInstance.search(false)
    },
    confirmComments() {
      const vueInstance = this;
      let formNo = '';
      const comments = vueInstance.comments;
      let tempQuotation = vueInstance.quotationList.find(quotation => quotation.uuid === vueInstance.quotationUuid);
      if (tempQuotation !== undefined) {
        tempQuotation.comments = vueInstance.comments;
        formNo = tempQuotation.formNo;
      }
      vueInstance.toggleLoading(true);
      vueInstance.$quotationHttp
        .patch("/cpc/updateComments", { formNo, comments })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    handleUpload(file) {
      this.file = file
      return false
    },
    downloadAttachment(row) {
      this.$downloadAttachment(this, row.id)
    },
    uploadApproveReferenceFile() {
      const vueInstance = this
      let fd = new FormData()
      fd.append("file", vueInstance.file)
      fd.append("description", "quotaion attachement")
      vueInstance.toggleLoading(true)
      vueInstance.$fileHttp
        .post("/attachment/upload-single?description=rfqQuoation", fd)
        .then(response => {
          vueInstance.cpcToSupervisorAttachments.push(response.data)
          vueInstance.file = null
        })
        .catch(error => {
          console.error(error)
          AlertError(vueInstance, error, true)
            .then(() => {});
        })
        .finally(() => {
          vueInstance.toggleLoading(false)
        })
    },
    deleteApproveReferenceFile(row) {
      const vueInstance = this
      vueInstance.cpcToSupervisorAttachments.splice(row._index, 1)
    },
    uploadRejectReferenceFile() {
      const vueInstance = this
      let fd = new FormData()
      fd.append("file", vueInstance.file)
      fd.append("description", "quotaion attachement")
      vueInstance.toggleLoading(true)
      vueInstance.$fileHttp
        .post("/attachment/upload-single?description=rfqQuoation", fd)
        .then(response => {
          vueInstance.cpcToVendorAttachments.push(response.data)
          vueInstance.file = null
        })
        .catch(error => {
          console.error(error)
          AlertError(vueInstance, error, true)
            .then(() => {});
        })
        .finally(() => {
          vueInstance.toggleLoading(false)
        })
    },
    deleteRejectReferenceFile(row) {
      const vueInstance = this
      vueInstance.cpcToVendorAttachments.splice(row._index, 1)
    },
    batchDelete() {
      const vueInstance = this
      AlertDelete(vueInstance).then(() => {
        vueInstance.toggleLoading(true)
        vueInstance.$quotationHttp
          .post("/cpc/rfq/batch/delete", {
            groupId: vueInstance.groupId,
            type: vueInstance.deleteType,
            deleteReason: vueInstance.deleteReason,
          })
          .then(response => {
            if (vueInstance.deleteType === "ALL") {
              let message = response.data?.messageList && response.data.messageList.length > 0 ? response.data.messageList[0] : "Delete will execute in the background.";
              AlertInfo(vueInstance, message)
                .then(() => {
                  vueInstance.$router.push({
                    name: "CPC_MAINTAIN",
                  });
                });
            } else {
              let message = response.data?.messageList && response.data.messageList.length > 0 ? response.data.messageList.join("<br>") : vueInstance.$t("COMMON_MESSAGE_DELETE_SUCCESS");
              AlertInfo(vueInstance, message)
                .then(() => {
                  vueInstance.reload();
                });
            }
          })
          .catch(error => {
            console.error(error)
            AlertError(vueInstance, error).then(() => { })
          })
          .finally(() => {
            vueInstance.toggleLoading(false)
          })
      })
    },
    batchSave() {
      const vueInstance = this
      const errorMessageArray = [];
      if ((vueInstance.batchValidFrom && !vueInstance.batchValidTo) || (!vueInstance.batchValidFrom && vueInstance.batchValidTo)) {
        errorMessageArray.push(vueInstance.$t("VALID_FROM_VALID_TO_NEED_PAIR"));
      }
      if (vueInstance.batchValidFrom) {
        const validFrom = new Date(vueInstance.batchValidFrom);
        const validTo = new Date(vueInstance.batchValidTo);
        if (validTo < validFrom) {
          errorMessageArray.push(vueInstance.$t("VALID_FROM_VALID_TO_DATE_INVALID"));
        }
        const dayDiff = (validTo - validFrom) / (1000 * 60 * 60 * 24);
        if (dayDiff > 548) {
          errorMessageArray.push(vueInstance.$t("VALID_FROM_VALID_TO_DATE_PERIOD_INVALID"));
        }
        const yearDiff = validTo.getFullYear() - validFrom.getFullYear();
        if (yearDiff >= 2) {
          errorMessageArray.push(vueInstance.$t("VALID_FROM_VALID_TO_YEAR_PERIOD_INVALID"));
        }
      }
      if (errorMessageArray.length > 0) {
        vueInstance.$Swal.fire({
          icon: "info",
          title: vueInstance.$t("COMMON_MESSAGE_INFO"),
          html: errorMessageArray.join("<br>")
        });
        return;
      }
      vueInstance.toggleLoading(true)
      vueInstance.$quotationHttp
        .patch("/cpc/rfq/batch/save", {
          groupId: vueInstance.groupId,
          comments: vueInstance.batchComments || null,
          validFrom: vueInstance.parseDate(vueInstance.batchValidFrom),
          validTo: vueInstance.parseDate(vueInstance.batchValidTo),
          cpcToSupervisorAttachments: vueInstance.cpcToSupervisorAttachments,
          cpcToVendorAttachments: vueInstance.cpcToVendorAttachments,
        })
        .then(response => {
          vueInstance.$Swal
            .fire({
              icon: "info",
              title: vueInstance.$t("COMMON_MESSAGE_INFO"),
              html: vueInstance.$t("COMMON_MESSAGE_SUCCESS"),
            })
            .then(() => {
              vueInstance.reload()
            })
        })
        .catch(error => {
          console.error(error)
          AlertError(vueInstance, error, true)
            .then(() => {});
        })
        .finally(() => {
          vueInstance.toggleLoading(false)
        })
    },
    save() {
      const vueInstance = this
      const errorMessageArray = [];
      vueInstance.quotationList.forEach(quotation => {
        if (!quotation.comments) {
          errorMessageArray.push(quotation.formNo + ": " + vueInstance.$t("PLEASE_KEY_IN") + vueInstance.$t("COMMENTS"));
        }
        if (!quotation.validFrom) {
          errorMessageArray.push(quotation.formNo + ": [" + vueInstance.$t("VALID_FROM") + "]" + vueInstance.$t("IS_REQUIRED"));
        }
        if (!quotation.validTo) {
          errorMessageArray.push(quotation.formNo + ": [" + vueInstance.$t("VALID_TO") + "]" + vueInstance.$t("IS_REQUIRED"));
        }
        if (quotation.validFrom && quotation.validTo) {
          const validFrom = new Date(quotation.validFrom);
          const validTo = new Date(quotation.validTo);
          if (validTo < validFrom) {
            errorMessageArray.push(quotation.formNo + ": " + vueInstance.$t("VALID_FROM_VALID_TO_DATE_INVALID"));
            return;
          }
          const dayDiff = (validTo - validFrom) / (1000 * 60 * 60 * 24);
          if (dayDiff > 548) {
            errorMessageArray.push(quotation.formNo + ": " + vueInstance.$t("VALID_FROM_VALID_TO_DATE_PERIOD_INVALID"));
            return;
          }
          const yearDiff = validTo.getFullYear() - validFrom.getFullYear();
          if (yearDiff >= 2) {
            errorMessageArray.push(quotation.formNo + ": " + vueInstance.$t("VALID_FROM_VALID_TO_YEAR_PERIOD_INVALID"));
            return;
          }
        }
      });
      if (errorMessageArray.length > 0) {
        vueInstance.$Swal.fire({
          icon: "info",
          title: vueInstance.$t("COMMON_MESSAGE_INFO"),
          html: errorMessageArray.join("<br>")
        });
        return;
      }
      vueInstance.toggleLoading(true)
      vueInstance.$quotationHttp
        .patch("/cpc/rfq/save", {
          quotationRequestList: vueInstance.quotationList.map(quotation => {
            return {
              formNo: quotation.formNo,
              comments: quotation.comments,
              validFrom: vueInstance.parseDate(quotation.validFrom),
              validTo: vueInstance.parseDate(quotation.validTo),
              materialType: quotation.materialType?.code,
              conditionValueForFRA1: quotation.conditionMap.FRA1,
              conditionValueForZOA1: quotation.conditionMap.ZOA1,
              conditionValueForZII1: quotation.conditionMap.ZII1,
              transportDays: quotation.transportDays,
              planDeliveryTime: quotation.planDelTime,
              minimumOrderQty: quotation.minOrderQty,
            }
          }),
        })
        .then(response => {
          vueInstance.$Swal.fire({
            icon: "info",
            title: vueInstance.$t("COMMON_MESSAGE_INFO"),
            html: vueInstance.$t("COMMON_MESSAGE_SUCCESS"),
          })
        })
        .catch(error => {
          console.error(error)
          AlertError(vueInstance, error, true)
            .then(() => {});
        })
        .finally(() => {
          vueInstance.toggleLoading(false)
        })
    },
    approve() {
      const vueInstance = this
      vueInstance.toggleLoading(true)
      vueInstance.$quotationHttp
        .post("/cpc/rfq/approve", {
          groupId: vueInstance.groupId,
        })
        .then(response => {
          vueInstance.$Swal
            .fire({
              icon: "info",
              title: vueInstance.$t("COMMON_MESSAGE_INFO"),
              html: response.data.content[0].status,
            })
            .then(() => {
              vueInstance.$router.push({
                name: "CPC_MAINTAIN",
              })
            })
        })
        .catch(error => {
          console.error(error)
          AlertError(vueInstance, error, true)
            .then(() => {});
        })
        .finally(() => {
          vueInstance.toggleLoading(false)
        })
    },
    reject() {
      const vueInstance = this
      vueInstance.toggleLoading(true)
      vueInstance.$quotationHttp
        .post("/cpc/rfq/reject", {
          groupId: vueInstance.groupId,
        })
        .then(response => {
          vueInstance.$Swal
            .fire({
              icon: "info",
              title: vueInstance.$t("COMMON_MESSAGE_INFO"),
              html: response.data.content[0].status,
            })
            .then(() => {
              vueInstance.$router.push({
                name: "CPC_MAINTAIN",
              })
            })
        })
        .catch(error => {
          console.error(error)
          AlertError(vueInstance, error, true)
            .then(() => {});
        })
        .finally(() => {
          vueInstance.toggleLoading(false)
        })
    },
    Delete() {
      const vueInstance = this
      if (vueInstance.selectedItems.length === 0) {
        return;
      } else {
        for (const i of vueInstance.selectedItems) {
          if (!i.comment) {
            AlertInfo(vueInstance, vueInstance.$t('COMMENTS') + vueInstance.$t('IS_REQUIRED'));
            return;
          }
        }
      }
      vueInstance.toggleLoading(true)
      vueInstance.$quotationHttp
        .post("/cpc/rfq/delete", {
          formNoList: vueInstance.selectedItems.map(item => item.formNo),
        })
        .then(response => {
          vueInstance.$Swal
            .fire({
              icon: "info",
              title: vueInstance.$t("COMMON_MESSAGE_INFO"),
              html: vueInstance.$t("DELETE_SUCCESS"),
            })
            .then(() => {
              vueInstance.search(true)
            })
        })
        .catch(error => {
          console.error(error)
          AlertError(vueInstance, error, true)
            .then(() => {});
        })
        .finally(() => {
          vueInstance.toggleLoading(false)
        })
    },
    handleSelectChange(selection) {
      this.selectedItems = selection.map(item => {
        return {
          formNo: item.formNo,
          comment: item.comments
        }
      });
    },
    Download() {
      let vueInstance = this
      vueInstance.toggleLoading(true)
      vueInstance.$quotationHttp
        .get("/rfq/download/" + vueInstance.getCpcGroupUuid(), { responseType: "blob" })
        .then(response => {
          vueInstance.toggleLoading(false)
          if (response.data) {
            DownloadFile(new Blob([response.data]), response.headers["content-disposition"].split('"')[1])
          }
        })
        .catch(error => {
          if (error.response.status == 444) {
            let text = "records to many, please fill in criteria or give a start and size of records."
            vueInstance.$Swal.fire({
              icon: "error",
              title: Translate("COMMON_MESSAGE_ERROR"),
              text,
            })
          }
        })
    },
    parseDate(date) {
      if (!(date instanceof Date) || isNaN(date)) {
        return null
      }

      return (
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        date
          .getDate()
          .toString()
          .padStart(2, "0")
      )
    },
    showCommentsModal(index, uuid) {
      const vueInstance = this
      vueInstance.comments = vueInstance.quotationList[index].comments ?? ""
      vueInstance.quotationUuid = uuid
      vueInstance.commentsModal = true
    },
    showHistoryCommentsModal(uuid) {
      const vueInstance = this
      vueInstance.toggleLoading(true)
      vueInstance
        .$queryQuotationLog(vueInstance, uuid)
        .then(data => {
          vueInstance.quotationUuid = uuid
          vueInstance.logComment = ""
          data.forEach(log => {
            if (log.quotationRole) {
              vueInstance.logComment = vueInstance.logComment + vueInstance.$t("ROLE") + ": " + log.quotationRole + ", "
            }
            if (log.quotationRole) {
              vueInstance.logComment = vueInstance.logComment + vueInstance.$t("STATUS") + ": " + log.flowStatus + ", "
            }
            if (log.groupAccount) {
              vueInstance.logComment =
                vueInstance.logComment +
                vueInstance.$t("GROUP_ACCOUNT") +
                ": " +
                log.groupAccount.code +
                "/" +
                log.groupAccount.companyName +
                ", "
            }
            if (log.created) {
              vueInstance.logComment =
                vueInstance.logComment + vueInstance.$t("CREATE_DATE") + ": " + log.created + ": <br>"
            }
            if (log.flowComment) {
              vueInstance.logComment = vueInstance.logComment + log.flowComment
            }
            vueInstance.logComment = vueInstance.logComment + '<hr style="border:1px dashed #000; height:1px">'
          })
          vueInstance.logCommentModal = true
        })
        .catch(error => {
          console.error(error)
          AlertError(vueInstance, error).then(() => { })
        })
        .finally(() => {
          this.toggleLoading(false)
        })
    },
    showInfoRecordMaintainModal(index) {
      const vueInstance = this
      vueInstance.quotation = vueInstance.quotationList[index]
      vueInstance.infoRecordMaintainModal = true
    },
    showScalePriceModal(index) {
      const vueInstance = this
      vueInstance.scalePrices = vueInstance.quotationList[index].quotationScalePriceList
      vueInstance.scalePricesModal = true
    },
    alertColorClass(row) {
      if (row.targetPrice !== row.unitPrice) {
        return "text-delta-yellow"
      }
      if (row.currentPrice === undefined || row.currentPrice === null || row.unitPrice === row.currentPrice) {
        return "text-delta-blue"
      }
      if (row.unitPrice > row.currentPrice) {
        return "text-delta-red"
      }
      return "text-delta-green"
    },
  },
  computed: {
    groupId: {
      get() {
        return this.getCpcGroupId()
      },
    },
    defaultValidTo: {
      get() {
        let today = new Date()
        return new Date(today.getFullYear() + (today.getMonth() + 1 > 9 ? 1 : 0), 11, 31)
      },
    },
    cpcToSupervisorAttachmentsExited() {
      return (
        this.cpcToSupervisorAttachments &&
        this.cpcToSupervisorAttachments.filter(attachment => !attachment.deleted).length > 0
      )
    },
    showCpcToSupervisorAttachments() {
      return this.cpcToSupervisorAttachmentsExited
        ? this.cpcToSupervisorAttachments.filter(attachment => !attachment.deleted)
        : []
    },
    cpcToVendorAttachmentsExited() {
      return (
        this.cpcToVendorAttachments && this.cpcToVendorAttachments.filter(attachment => !attachment.deleted).length > 0
      )
    },
    showCpcToVendorAttachments() {
      return this.cpcToVendorAttachmentsExited
        ? this.cpcToVendorAttachments.filter(attachment => !attachment.deleted)
        : []
    },
    selectAllAble() {
      return (
        this.getCpcStatusEnum()["statusViewEnum"] == "WAITING_BUYER" ||
        this.getCpcStatusEnum()["statusViewEnum"] == "WAITING_SUPPLIER" ||
        this.getCpcStatusEnum()["statusViewEnum"] == "WAITING_BUYER_SUPPLIER"
      )
    },
    modalSize() {
      return this.getModalSize()
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    },
    supplierQuotationFilesExited() {
      return (
        this.supplierQuotationFiles && this.supplierQuotationFiles.filter(attachment => !attachment.deleted).length > 0
      )
    },
    showSupplierQuotationFiles() {
      return this.supplierQuotationFilesExited
        ? this.supplierQuotationFiles.filter(attachment => !attachment.deleted)
        : []
    },
    highPriceExited() {
      return this.quotationList && this.quotationList.filter(quotation => quotation.highPrice).length > 0
    },
    quotationColumnList() {
      let cols = [
        {
          title: this.$t("ALERT"),
          align: "center",
          width: 70,
          slot: "alert",
        },
        {
          title: this.$t("COMMENTS"),
          align: "center",
          width: 90,
          slot: "comments",
        },
        {
          renderHeader: (h, params) => {
            return h("div", {}, [this.$t("HISTORY"), h("br"), this.$t("COMMENTS")])
          },
          align: "center",
          width: 70,
          slot: "historyComments",
        },
        {
          title: this.$t("NEW_AND_OLD"),
          align: "center",
          width: 60,
          slot: "newAndOld",
        },
        {
          title: this.$t("INFO_RECORD"),
          align: "center",
          width: 60,
          slot: "infoRecord",
        },
        {
          title: this.$t("HIGH_PRICE"),
          align: "center",
          width: 60,
          slot: "highPrice",
        },
        {
          renderHeader: (h, params) => {
            return h("div", {}, [this.$t("DELTA_PN"), h("br"), this.$t("PN_DESCRIPTION")])
          },
          align: "center",
          width: 100,
          slot: "deltaPartAndDeltaPartDescription",
        },
        {
          title: this.$t("VENDOR_PN"),
          align: "center",
          width: 80,
          key: "vendorPartNo",
        },
        {
          title: this.$t("RFQ_QUANTITY"),
          align: "center",
          width: 60,
          key: "rfqQty",
        },
        {
          title: this.$t("ITEM_CATEGORY"),
          align: "center",
          width: 100,
          slot: "itemCategory",
        },
        {
          title: this.$t("PLANT_CODE"),
          align: "center",
          width: 50,
          key: "plant",
        },
        {
          renderHeader: (h, params) => {
            return h("div", {}, [this.$t("TARGET"), h("br"), this.$t("PRICE")])
          },
          align: "center",
          width: 60,
          key: "targetPrice",
        },
        {
          renderHeader: (h, params) => {
            return h("div", {}, [this.$t("CURRENT"), h("br"), this.$t("PRICE")])
          },
          align: "center",
          width: 60,
          key: "currentPrice",
        },
        {
          renderHeader: (h, params) => {
            return h("div", {}, [this.$t("UNIT_PRICE"), h("br"), this.$t("CURRENCY")])
          },
          align: "center",
          width: 90,
          slot: "unitPriceAndCurrency",
        },
        {
          title: "RFQ CD%",
          align: "center",
          width: 90,
          slot: "rfqCd",
        },
        {
          title: "Target CD%",
          align: "center",
          width: 90,
          slot: "targetCd",
        },
        {
          renderHeader: (h, params) => {
            return h("div", {}, [this.$t("VALID_FROM"), h("br"), this.$t("VALID_TO")])
          },
          align: "center",
          width: 140,
          slot: "validFromAndValidTo",
        },
        {
          renderHeader: (h, params) => {
            return h("div", {}, [this.$t("SCALE"), h("br"), this.$t("PRICE")])
          },
          align: "center",
          width: 60,
          slot: "scalePrice",
        }
      ];
      if (this.isWaitingSupplier) {
        cols.unshift({
          type: 'selection',
          width: 60,
          align: 'center'
        })
      }
      return cols;
    },
    scalePriceColumnList() {
      return [
        {
          title: "Item",
          align: "center",
          width: 80,
          key: "item",
        },
        {
          renderHeader: (h, params) => {
            return h("div", {}, [this.$t("SCALE"), h("br"), this.$t("QUANTITY")])
          },
          align: "center",
          key: "scaleQuantity",
        },
        {
          renderHeader: (h, params) => {
            return h("div", {}, [this.$t("SCALE"), h("br"), this.$t("PRICE")])
          },
          align: "center",
          key: "scalePrice",
        },
      ]
    },
    isDeleteDisabled() {
      return this.selectedItems.length === 0;
    },
    isWaitingSupplier() {
      return this.rfqStatus === 'WAITING_SUPPLIER';
    },
    isWaitingBuyer() {
      return this.rfqStatus === 'WAITING_BUYER';
    }
  },
}
</script>

<style scoped>
/* table {
    width: 200% !important;
  } */
</style>
